import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html', // Ensure this file exists in the same folder as notfound.ts
  styleUrls: ['./notfound.component.scss']   // Ensure this file exists in the same folder as notfound.ts
})
export class NotFoundComponent {
  constructor(private router: Router) {}

  goHome(): void {
    this.router.navigate(['/']);
  }
}
